const appHeight = () => {
  const doc = document.documentElement;
  doc.style.setProperty('--app-height', `${window.innerHeight}px`);
  if (document.querySelector('.c-header')) {
    doc.style.setProperty(
      '--app-header-height',
      `${document.querySelector('.c-header').offsetHeight}px`,
    );
  }
};
window.addEventListener('resize', appHeight);
appHeight();
